module.exports = __webpack_public_path__ + "img/frame (270).9faa563d.jpg";